<template>
<div>
<div v-if="isLoading" class="loading">Loading&#8230;</div>

        
 
<!-- style="margin-top:-.5em;" -->
        <div class="columns is-multiline is-gapless" >   
            <div class="column is-2 is-uppercase has-text-weight-bold has-text-centered has-text-white has-background-warning-dark">{{comp.comp_CODE}}</div>               
            <div class="column is-8 is-size-7 has-text-weight-bold is-uppercase colBorderThin  has-background-warning-light">&nbsp;{{comp.comp_TITRE_F}}</div>
            <div @click="filter_osa_select()" class="column is-2 is-uppercase has-text-weight-bold has-text-centered has-text-white has-background-link-dark"><span class="icon is-small"><i class="fas fa-hand-pointer"></i></span></div>               
            

<div class="column is-12">
    <div class="columns is-multiline is-gapless" style="margin-bottom:0em;">
        <div class="column is-3 is-size-7 colBorderThin isLink hoverIt hoverItBack"  v-for ="(data, index) in filter_osa_student()" :key="index">
            <TranmissionOSATran 
            :stud="data"
            :key="randomTran_ID()"
            > </TranmissionOSATran>
        </div>
</div></div>



        </div>




</div>
</template>

<script>
import moment from 'moment';
import { bus } from '@/main'
import TranmissionOSATran  from '@/components/Comp_Transmission_OSA_tran';

//, 'sess', 'ann'
export default {
        props: [ 'comp' , 'comps_all' , 'studs' , 'sessann' ],
        components: { TranmissionOSATran },

        data() {
            return {


                isLoading:false,
                is_selected: false,
                tran_selected_id: '',
                smokes :'smokes'
            }
        },



mounted() {





}, // END CREATED

methods : { 


return_style_select:function(index) {

    if (this.studs[index].isSelected == 1) {return 'has-background-success'}
    else {return 'has-background-white'}
},

click_box:function(index) {
    if (this.studs[index].isSelected == 0) {this.studs[index].isSelected = 1}
    else {this.studs[index].isSelected = 0}
},


filter_osa_student:function() {

    var arrReturn = []
    var self = this;
    this.studs.forEach(function(item){   
        if (item.cour_ID == self.comp.cour_ID && item.sessann == self.sessann) 
        {
            item.comp_CODE = self.comp.comp_CODE
            arrReturn.push(item); 
        }
    });
    return arrReturn
},

filter_osa_select:function() {

    var self = this;
    this.studs.forEach(function(item){   
        if (item.cour_ID == self.comp.cour_ID && item.sessann == self.sessann) 
        {item.isSelected = 1;}
    });
},




filter_osa_student_X:function() {

    var arrReturn = []
    var self = this;
    this.comps_all.forEach(function(item){   
        if (item.comp_ID == self.comp.comp_ID) 
        {arrReturn.push({cour_ID: item.cour_ID});}
    });


setTimeout(() => {
    var res = this.studs.filter(item => !arrReturn.includes(item.cour_ID));
    console.log( res)
    return res;
}, 100);

},




// GENERATE ID FOR TRANSACTION -- SAVE TO DB (NEW) 
    randomTran_ID:function() {

        return 'xxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
    });},

// WHAT ABOUT REMOVAL !!!! 
    hop_on_tran_bus:function (op){ 
        this.is_selected=true; 
        this.tran_selected_id = this.type + this.randomTran_ID()
        bus.$emit('hop_on_for_tran', this.stud , this.type , op , this.tran_selected_id );
    },

    hop_off_tran_bus:function () {
        this.is_selected=false;
        bus.$emit('hop_off_for_tran', this.tran_selected_id , this.type);
    },












}, // END METHODS


}
</script>